import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import App from '../providers/App.tsx'

const container = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(container))
  root.render(app)
} else {
  // The hot module reloading API is not available in production.
  createRoot(container).render(app)
}
